<div class="wrapper">
    <!-- start .row -->
    <div class="row">
        <div class="col-sm-12 wtw-hero-image">
            <img id="BGprincipal" class="img-responsive" src="./assets/global/images/cabeceras/bg_admin_auditoria.jpg">
            <h1 class="wtw-bg-black col-lg-5" style="margin-left: 15px">Administración</h1>
        </div>
    </div>
    <!-- end .row -->

    <div class="container-fluid">

        <!-- Page-Title -->
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                    <div class="btn-group pull-right">
                        <ol class="breadcrumb hide-phone p-0 m-0">
                            <li class="breadcrumb-item"><a href="#">Inicio</a></li>
                            <li class="breadcrumb-item"><a href="#">Administración</a></li>
                            <li class="breadcrumb-item"><a href="#">Paramétricas</a></li>
                            <li class="breadcrumb-item"><a href="#">Estados</a></li>
                        </ol>
                    </div>
                    <h4 class="page-title">Administración Paramétricas</h4>
                </div>
            </div>
        </div>
        <!-- end page title end breadcrumb -->
        <!-- tipos de estados -->
        <div class="row" *ngIf="!frameState">
            <div class="col-lg-6">
                <div class="card-box">
                    <h4 class="header-title mb-3">Información Tipo Estados</h4>
                    <div class="table-responsive">
                        <table
                            class="table table-hover m-0 table-centered tickets-list table-actions-bar dt-responsive nowrap"
                            cellspacing="0" width="100%" id="datatableInfEst">
                            <thead>
                                <tr>
                                    <th>Ver</th>
                                    <th>Tipo Estado</th>
                                    <th>Modificar</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of ListEstados">
                                    <td><a (click)="listEstado(item.idAdmTipoEstado)" class="btn btn-sm btn-info"><i
                                                class="mdi mdi-eye-outline"></i></a></td>
                                    <td>{{item.nombre}}</td>
                                    <td><a (click)="editar(item.nombre,item.idAdmTipoEstado)"
                                            class="btn btn-sm btn-purple"><i class="mdi mdi-pencil"></i></a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>


                    <!-- <h4 class="m-t-0 header-title">Información Tipo Estados</h4>
                    <div class="table-responsive">
                        <table class="table table-hover table-centered m-0"
                            *ngIf="tipoEstadoService.listTipoEstado && tipoEstadoService.listTipoEstado.length">
                            <thead>
                                <tr>
                                    <th>Ver</th>
                                    <th>Tipo Estado</th>
                                    <th>Modificar</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of tipoEstadoService.listTipoEstado">
                                    <td><a (click)="listEstado(item.idAdmTipoEstado)" class="btn btn-sm btn-info"><i
                                                class="mdi mdi-eye-outline"></i></a></td>
                                    <td>{{item.nombre}}</td>
                                    <td><a (click)="editar(item.nombre,item.idAdmTipoEstado)"
                                            class="btn btn-sm btn-purple"><i class="mdi mdi-pencil"></i></a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div> -->
                </div>
            </div>
            <div class="col-lg-6">
                <div class="card-box">
                    <h4 class="m-t-0 header-title">Actualizar Tipo Estados</h4>
                    <form [formGroup]="formTipoEstado">
                        <div class="form-row ">
                            <div class="form-group col-md-12">
                                <label for="userName">Estado<span class="text-danger">*</span></label>
                                <input type="text" formControlName="nombre" parsley-trigger="change"
                                    class="form-control" id="nombre">
                            </div>

                            <div class="actions clearfix">
                                <button type="button" (click)="onSubmit()"
                                    class="btn btn-custom waves-effect waves-light">
                                    <i class="fi-plus"></i>Editar Estado
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <!-- manejar los estados -->
        <div class="row" *ngIf="frameState">
            <div class="col-lg-6">
                <div class="card-box">
                    <h4 class="header-title mb-3">Información Estados</h4>
                    <div class="table-responsive">
                        <table
                            class="table table-hover m-0 table-centered tickets-list table-actions-bar dt-responsive nowrap"
                            cellspacing="0" width="100%" id="datatableEst">
                            <thead>
                                    <tr>
                                        <th>Estado</th>
                                        <th>Modificar</th>
                                        <th>Eliminar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of ListEstadosByTipo">
                                        <td>{{item.nombre}}</td>
                                        <td><a (click)="editarEstado(item.nombre,item.idAdmEstado)"
                                                class="btn btn-sm btn-purple"><i class="mdi mdi-pencil"></i></a>
                                        </td>
                                        <td><a (click)="deleteEstado(item.idAdmEstado)" class="btn btn-sm btn-danger"><i
                                                    class="mdi mdi-delete"></i></a>
                                        </td>
                                    </tr>
                                </tbody>
                        </table>
                    </div>


                    <!-- <h4 class="m-t-0 header-title">Información Estados</h4>
                    <div class="table-responsive">
                        <table class="table table-hover table-centered m-0"
                            *ngIf="estadoService.listEstado && estadoService.listEstado.length">
                            <thead>
                                <tr>
                                    <th>Estado</th>
                                    <th>Modificar</th>
                                    <th>Eliminar</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of estadoService.listEstado">
                                    <td>{{item.nombre}}</td>
                                    <td><a (click)="editarEstado(item.nombre,item.idAdmEstado)"
                                            class="btn btn-sm btn-purple"><i class="mdi mdi-pencil"></i></a>
                                    </td>
                                    <td><a (click)="deleteEstado(item.idAdmEstado)" class="btn btn-sm btn-danger"><i
                                                class="mdi mdi-delete"></i></a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div> -->
                </div>
            </div>
            <div class="col-lg-6">
                <div class="card-box">
                    <h4 class="m-t-0 header-title">Actualizar Estados</h4>
                    <form [formGroup]="formEstado">
                        <div class="form-row ">
                            <div class="form-group col-md-12">
                                <label for="userName">Estado<span class="text-danger">*</span></label>
                                <input type="text" formControlName="nombre" parsley-trigger="change"
                                    class="form-control" id="nombre">
                            </div>

                            <div class="actions clearfix">
                                <button type="button" *ngIf="!edit" (click)="onSubmitState()"
                                    class="btn btn-custom waves-effect waves-light">
                                    <i class="fi-plus"></i>Agregar Estado
                                </button>
                                <button type="button" *ngIf="edit" (click)="submitUpdate()"
                                    class="btn btn-custom waves-effect waves-light">
                                    <i class="fi-plus"></i>Actualizar Estado
                                </button>
                                <button type="button" (click)="cancelState()"
                                    class="btn btn-danger">
                                    <i class="less-than"></i>Atras
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    </div> <!-- end container -->
</div>
<!-- end wrapper -->
<div class="blanco"></div>